import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../ui/card';
import { CreditSubmission } from '../../../../api/creditSubmissionApi';
import { formatCurrency } from './utils';

interface DetailSection2Props {
  submission: CreditSubmission;
}

export default function DetailSection2({ submission }: DetailSection2Props) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>2. Kebutuhan Pinjaman</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div>
            <label className="text-sm text-gray-600">Profil Singkat Calon Debitur</label>
            <p className="mt-1">{submission.debtor_profile || '-'}</p>
          </div>
          <div>
            <label className="text-sm text-gray-600">Tujuan Pinjaman</label>
            <p className="mt-1">{submission.loan_purpose || '-'}</p>
          </div>
          <div>
            <label className="text-sm text-gray-600">Jumlah yang Diminta</label>
            <p className="font-medium mt-1 text-lg">
              {formatCurrency(submission.requested_amount)}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
